import { sizes } from '@sharefiledev/antd-config';
import { Flex, Grid, Skeleton } from 'antd';

export const MastheadSkeleton = () => {
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = screens.xs;

	return (
		<Flex justify="center" align="center" vertical style={{ padding: `${sizes.MD} 0` }}>
			<Flex style={{ width: isMobile ? '95%' : '80%' }}>
				<Skeleton.Input block />
			</Flex>
		</Flex>
	);
};
